import type { ReactNode } from 'react'
import { Reveal } from '@/components/ui/Reveal'

interface ContentBlockProps {
  /** Small step number/label shown above the heading, e.g. "01" */
  label?: string
  title: string
  children: ReactNode
}

/** Long-form text block: heading on the left, prose on the right. */
export const ContentBlock = ({ label, title, children }: ContentBlockProps) => (
  <Reveal className="border-t border-base-200 py-10 first:border-t-0 first:pt-0">
    <div className="grid gap-5 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
      <div>
        {label && (
          <span className="mb-3 flex items-center gap-3 font-display text-sm text-gold-500">
            <span aria-hidden="true" className="h-px w-6 bg-gold-500" />
            {label}
          </span>
        )}
        <h2 className="font-display text-2xl leading-tight tracking-tight text-base-900 sm:text-3xl">
          {title}
        </h2>
      </div>
      <div className="space-y-4 text-base leading-7 text-base-600">{children}</div>
    </div>
  </Reveal>
)

/** Highlighted quotation used inside a ContentBlock. */
export const PullQuote = ({ children }: { children: ReactNode }) => (
  <blockquote className="rounded-r-2xl border-l-2 border-gold-400 bg-gold-50/70 py-4 pl-5 pr-4 font-display text-xl leading-snug text-base-900">
    {children}
  </blockquote>
)
